import { NgModule } from '@angular/core';
import { AppSharedModule } from '../app-shared.module';
import { ComponentsModule } from '../components/components.module';
import { ProcessoDocumentoModule } from '../processo-documento/processo-documentos.module';
import { ProcessoIdentificacaoPeticaoInicialModule } from '../processo-identificacao-peticao-inicial/processo-identificacao-peticao-inicial.module';
import { ProcessoHistoricoComponent } from './processo-historico/processo-historico.component';
import { ProcessoListaComponent } from './processo-lista/processo-lista.component';
import { ProcessoVisualizadorComponent } from './processo-visualizador/processo-visualizador.component';
import { ProcessoRoutingModule } from './processo.routing';
import { ProcessoService } from './processo.service';
import {ProcessoCompiladoService} from '../processo-compilado/processo-compilado.service';
import {ProcessoLinhaTempoComponent} from './processo-linha-tempo/processo-linha-tempo.component';

@NgModule({
  imports: [
    AppSharedModule,
    ComponentsModule,
    ProcessoIdentificacaoPeticaoInicialModule,
    ProcessoDocumentoModule,
  ],
  declarations: [
    ProcessoHistoricoComponent,
    ProcessoListaComponent,
    ProcessoVisualizadorComponent,
    ProcessoLinhaTempoComponent
  ],
  exports: [
    ProcessoRoutingModule
  ],
  providers: [
    ProcessoService,
    ProcessoCompiladoService
  ]
})
export class ProcessoModule {}
